import React from "react";
import "./HotelListItem.css";
import {Link} from "react-router-dom";
import ListEditButtons from "../ListEditButtons/ListEditButtons";
import Ratings from 'react-ratings-declarative';

function HotelListItem(props) {

	let buttonColorStyle = {};
	if (props.differentColorButton) {
		buttonColorStyle = {backgroundColor: "#671b74"}
	}

    return (
        <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className='card card-spacer'>
                <Link to={'/hotels/' + props.id}>
                    <img className="card-img-top"
                         src={(props.imageUrl && props.imageUrl.trim() !== "") ? props.imageUrl : "/images/noimage.png"}
                         alt="Hotel"/>
                </Link>
                <div className="card-img-overlay">

                </div>
                <div className="card-body">
                    <Link to={"/ratings/" + props.id}
                    >
                        <Ratings
                            rating={props.averageRatings/2}
                            widgetDimensions="15px"
                            widgetSpacings="2px"
                        >
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange" />
                            <Ratings.Widget widgetRatedColor="orange"/>
                        </Ratings>
                    </Link>
                    <h3 className="card-title hotelListName"><Link to={'/hotels/' + props.id}>{props.name}</Link></h3>
                    <hr/>
                    <h4 className="card-title">{props.address}</h4>

                    <div className="justify-content-between">

                        <p className="card-text">
                            <i className="material-icons"
                               title="Number of rooms">vpn_key
                            </i>
	                        <span style={{position: 'relative', bottom: 6, fontSize: 16, fontWeight: 'bold'}}> 2</span>
                        </p>
                        <Link to={'/hotels/' + props.id} className="btn btn-primary" style={buttonColorStyle}>
                            Go to the hotel
                        </Link>
                        <div>
                            <ListEditButtons
                                to={"/modify-hotel/" + props.id}
                                deleteHandler={props.deleteHandler}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HotelListItem;



// WEBPACK FOOTER //
// ./src/components/HotelListItem/HotelListItem.jsx